const { REACT_APP_API_URL } = process.env;

export { REACT_APP_API_URL };
